const state = {
  vacancy: {
    name: "",
  },
};

const getters = {
  getVacancy: (state) => state.vacancy,
};

const mutations = {
  setVacancy(state, vacancy) {
    state.vacancy = vacancy;
  },
};

const actions = {
  updateVacancy({ commit }, vacancy) {
      commit("setVacancy", vacancy);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
